import enums from '@/plugins/enums'

export const getOnsiteDispatcherActionButtons = function () {
  const appointmentStatus = this.row.latest_appointment?.status
  const isAssignedValuer = this.row.valuer?.is_self
  const isOwner = this.row.owner?.is_self
  const curUser = this.curUser

  return [
    {
      label:
        appointmentStatus === enums.appointmentStatus.PENDING_CONFIRMATION && isAssignedValuer
          ? 'confirm-appointment'
          : 'appointment',
      color: 'main',
      icon:
        appointmentStatus === enums.appointmentStatus.PENDING_CONFIRMATION && isAssignedValuer
          ? 'mdi-pencil'
          : 'mdi-eye',
      valuationTypes: ['avm', 'dvm', 'ovm'],
      show:
        ['ovm', 'oepc'].includes(this.row.valuation_type) &&
        //is dispatcher
        ((this.curUser.hasRole('dispatcher', this.row.valuation_type) &&
          (this.row.borrower_status === 'details_pending' ||
            appointmentStatus !== enums.appointmentStatus.COMPLETED)) ||
          // is owner or valuer
          ((isOwner || (isAssignedValuer && this.row.payment_summary?.is_payment_completed)) &&
            appointmentStatus &&
            appointmentStatus !== enums.appointmentStatus.COMPLETED &&
            appointmentStatus !== enums.appointmentStatus.INCOMPLETE)),

      to: {
        name: 'expert.summary',
        query: {
          valuation_request_ref: this.row.valuation_request_ref,
        },
      },
    },
    {
      label: 'edit',
      color: 'main',
      icon: 'mdi-sim-alert',
      valuationTypes: ['ovm'],
      show: this.curUser.hasRole('dispatcher', 'ovm') && this.row.tx_discrepancy,
      to: {
        name: 'valuation.request',
        params: { action: 'submit' },
        query: {
          valuation_request_ref: this.row.valuation_request_ref,
        },
      },
    },
    {
      label: 'ovm',
      color: 'main',
      icon: curUser.hasRole('valuer', 'ovm') ? 'mdi-pencil' : 'mdi-eye',
      valuationTypes: ['avm', 'dvm', 'ovm'],
      show:
        ((this.curUser.hasRole('valuer', 'ovm') && isAssignedValuer) ||
          this.curUser.hasRole('dispatcher', 'ovm')) &&
        this.row.valuation_type === 'ovm' &&
        (this.row.status === enums.requestStatus.SUBMITTED || curUser.hasRole('dispatcher', 'ovm')) &&
        (appointmentStatus !== enums.appointmentStatus.PENDING_CONFIRMATION || this.row.whitelabel),
      to: {
        name: `valuation.valuer-app.general`,
        query: {
          valuation_request_ref: this.row.valuation_request_ref,
        },
      },
    },
  ]
}
